import axios from "axios";
import { Inscription } from "../../domain/entities/inscription/Inscription";
import { urlInscriptionInProcess, urlInscriptionStructure, urlInscriptionById, urlInscriptionInProcessAutoSave, urlInscriptionInProcessOnlinePayment, urlInscriptionInProcessInfo, urlNewInscriptionId, urlInscriptionMerits, urlInscriptionExams, getInscriptionPrev, urlPaymentRedsysData, urlInscriptionAttachMerits, urlInscriptionAttachMeritsFiles, urlPaymentGttCaixaData, urlGetIP, inscriptionJustifyUrl, urlMakePaymentRedsys } from "./services.config";
import * as SecurityService from "../../application/services/SecurityService";
import { buildFormData } from '../../domain/utils/buildFormData';

var mgr = new SecurityService.default();

async function setToken() {
    await mgr.getAcessToken().then(
        acessToken => {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + acessToken
        }, err => {
            console.log(err)
        })
}

export const finishInscription = async function (data: Inscription) {
    await setToken();
    return new Promise((resolve, reject) => {
        axios.put(urlInscriptionInProcess(data.id), data.toServer())
            .then((response: any) => resolve(response))
            .catch((error: any) => reject(error));
    })
}

export const finishAttachMerits = async function (nif: string, data: Inscription) {
    await axios.put(urlInscriptionAttachMerits(nif, data), data.meritsToServer());
}

export const attachMeritsFiles = async function (data: any, nif: string) {
    const formData = new FormData();
    Object.entries(data).forEach(key => {
        if (key[1] != null) {
            formData.append(key[0], (key[1] as any))
        }
    });
    await axios.post(urlInscriptionAttachMeritsFiles(nif, data.inscriptionId), formData, { headers: { 'Content-Type': 'multipart/form-data' } });
}

export const payInscription = async function (data: Inscription) {
    await setToken();
    return new Promise((resolve, reject) => {
        axios.put(urlInscriptionInProcessOnlinePayment(data.id), data.toServer())
            .then((response: any) => resolve(response))
            .catch((error: any) => reject(error));
    })
}

export const postInscriptionAutoSave = async function (data: Inscription) {
    await setToken();
    return new Promise((resolve, reject) => {
        axios.put(urlInscriptionInProcessAutoSave(data.id), data.toServer())
            .then((response: any) => resolve(response))
            .catch((error: any) => reject(error));
    })
}


export const getInscriptionStructure = async function (callId: string, isPreview: boolean = false) {
    return new Promise((resolve, reject) => {
        resolve(axios.get(urlInscriptionStructure(callId, isPreview)));
    })
}

export const getInscriptionById = async function (inscriptionId: string) {
    await setToken();
    return new Promise((resolve, reject) => {
        resolve(axios.get(urlInscriptionById(inscriptionId)));
    })
}

export const getProcessInfoByInscription = async function (inscriptionId: string) {
    await setToken();
    return new Promise((resolve, reject) => {
        resolve(axios.get(urlInscriptionInProcessInfo(inscriptionId)));
    })
}

export let getNewInscriptionId = async function (newInscriptionIdCommand: { processId: string, nif: string, applicantData: Object, representativeData: Object, formFile: File }) {
    const formData = new FormData();
    buildFormData(formData, newInscriptionIdCommand);
    await setToken();
    return new Promise((resolve, reject) => {
        resolve(axios.post(urlNewInscriptionId(newInscriptionIdCommand.applicantData), formData, { headers: { 'Content-Type': 'multipart/form-data' } }));
    })
}

export let getInscriptionsMeritsData = async function (inscriptionId: string) {
    await setToken();
    return new Promise((resolve, reject) => {
        resolve(axios.get(urlInscriptionMerits(inscriptionId)));
    })
}

export let getInscriptionsExamsData = async function (inscriptionId: string) {
    await setToken();
    return new Promise((resolve, reject) => {
        resolve(axios.get(urlInscriptionExams(inscriptionId)));
    })
}

export let getInscriptionPreview = async function (processId: string) {
    return new Promise((resolve, reject) => {
        resolve(axios.get(getInscriptionPrev(processId)));
    })
}

export let getRedsysPaymentData = async function (inscriptionId: string, paymentOrder: string) {
    return new Promise((resolve, reject) => {
        resolve(axios.get(urlPaymentRedsysData(inscriptionId, paymentOrder)));
    })
}

export let sendRedsysPaymentData = async function (payload: { inscriptionId: string, paymentOrder: string, clientId: string, notification: FormData }) {
    return new Promise((resolve, reject) => {
        resolve(axios.post(urlMakePaymentRedsys(payload.inscriptionId, payload.paymentOrder, payload.clientId), payload.notification));
    })
}

export let getCaixaPaymentData = async function (inscriptionId: string, paymentOrder: string) {
    return new Promise((resolve, reject) => {
        resolve(axios.get(urlPaymentGttCaixaData(inscriptionId, paymentOrder)));
    })
}

export let getIP = async function () {
    return new Promise((resolve, reject) => {
        resolve(axios.get(urlGetIP()));
    })
}

export const getInscriptionJustify = async function (inscriptionId: string) {
    try {
        await setToken();
        const response = await axios.get(inscriptionJustifyUrl(inscriptionId));
        return response.data;
    } catch (error) {
        console.error(error);
    }
};
